/**
 * Created by hengbao on 2018/4/24.
 */
import getQueryJsonAll from 'bjxy-common/helper/getQueryJsonAll'
import addUrlQuery from 'bjxy-common/helper/addUrlQuery'
import './initKeyword'

let currentAccount = {
  convert_id: '',
  event_type: ''
};
let config = {}

// 头条

function toutiaoInit(item) {
  if (!window._taq) {
    currentAccount = item;
    const ta = document.createElement('script');
    ta.type = 'text/javascript';
    ta.async = true;
    ta.src = document.location.protocol + '//' + 's3.pstatp.com/bytecom/resource/track_log/src/toutiao-track-log.js';
    ta.onerror = function() {
      const request = new XMLHttpRequest();
      const web_url = window.encodeURIComponent(window.location.href);
      const js_url = ta.src;
      const url = '//ad.toutiao.com/link_monitor/cdn_failed?web_url=' + web_url + '&js_url=' + js_url + '&convert_id=' + currentAccount.convert_id;
      request.open('GET', url, true);
      request.send(null);
    };
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ta, s);
  }
  let json = getQueryJsonAll();
  let url = 'https://aso.xiaoying.com/api/v2/6631256571f74e71c7dfdbb16719e7ac/toutiaoH5/ad_click';
  let src = addUrlQuery(url, json)
  let eleImg = document.createElement('img');
  eleImg.src = src
}
export function toutiaoPush() {
  if (window._taq && currentAccount) {
    _taq.push(currentAccount);
  } else {
    return;
  }
};

// 豆盟
function doumengInit() {
  if (!(window._ai_analysis)) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://interaction.bayimob.com/static/hdggstatistics.js';
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(script, s);
  }
}
export function doumengPush() {
  if (window._ai_analysis) {
    _ai_analysis(['trackEvent', 'register', 'button', 'click']);
  }
};
// 豆盟测试需要带的参数
// ?appkey=4fc7e9c4df30aafd8b7e1ab324f27712&adSpaceKey=7f39f8317fbdb1988ef4c628eba02591&doumobkey=luerL6PIqVWIUeYu3XHe2g%3D%3D&gamename=%E5%A4%A7%E8%BD%AC%E7%9B%98&uid=uid_0412_926c9d53-4507-455c-bbea-1ca93229d284&t=1523527944825
function baiduInit() {
  if (!window._agl) {
    window._agl = [];
    _agl.push(
        ['production', '_f7L2XwGXjyszb4d1e2oxPybgD']
    );
    const agl = document.createElement('script');
    agl.type = 'text/javascript';
    agl.async = true;
    agl.src = 'https://fxgate.baidu.com/angelia/fcagl.js';
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(agl, s);
  }
}

export function baiduPush(cb) {
  if (window._agl&&window._agl.push) {
    window._agl && window._agl.push(['track', ['success', {t: 3}]]);
  }
};
// 360上报
function js360Init() {
  (function(b, a, e, h, f, c, g, s) {
    b[h] = b[h] || function() {
      (b[h].c = b[h].c || []).push(arguments);
    };
    b[h].s = !!c;
    g = a.getElementsByTagName(e)[0];
    s = a.createElement(e);
    s.src = '//s.union.360.cn/' + f + '.js';
    s.defer = !0;
    s.async = !0;
    g.parentNode.insertBefore(s, g);
  })(window, document, 'script', '_qha', 294217, false);
}

export function js360Push(id = 3033337166) {
  (function(w, n) {
    if (!w[n]) {
      return false;
    }
    w[n] = typeof w[n] === 'function' ? w[n] : function() {
      (w[n].c = w[n].c || []).push(arguments);
    };
    _qha('send', {
      et: 31,
      order: [
        {
          id: id, /* 注册id, 必填项*/
          orderType: '1'/* 常量，请勿修改*/
        }]
    });
  })(window, '_qha');
};

function mtaInit () {
  window._mtac = {senseQuery:1};
  var mta = document.createElement('script');
  mta.src = '//pingjs.qq.com/h5/stats.js?v2.0.4';
  mta.setAttribute('name', 'MTAH5');
  mta.setAttribute('sid', '500703215');
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(mta, s);
}


function fireEvent(eventType, eventName) {
  if (config.extend.is_inmobi != 1) return
  const PROPERTY_ID = 'ecab4d12992a404b817fa038b9fa56e7';
  const PING_SERVER_URL = 'https://advertiser.inmobiapis.cn/tpce/v1/events/'+eventType+'?trackingPartner=InMobi&country=CN';
  const pageData = {};
  if (typeof InmobiPixel != 'undefined') {
    window.inmobiPixel = new InmobiPixel();
    window.inmobiPixel.init({
      pingServer: PING_SERVER_URL,
      propertyId: PROPERTY_ID,
      domain: 'xiaoying.com',
      ping: true,
      ping_interval: 1000
    });
  }
  window.inmobiPixel && window.inmobiPixel.ping(eventName, pageData);
}
function fireCustomEvent(eventName) {
  fireEvent('custom', eventName);
}
export const inmobiEvent = {
  fireCustomEvent,
  fireDownloadEvent: function() {
    fireEvent('download', 'download');
  }
};

function inmobiInit() {
  const ta = document.createElement('script');
  ta.type = 'text/javascript';
  ta.src = 'https://inmobi.oss-cn-hangzhou.aliyuncs.com/pixel/inmobipixel.js';
  ta.onload = function() {
    fireCustomEvent('xiaoying_lp')
  };
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(ta, s);

  const boby = document.getElementsByTagName('boby');
  boby.onscroll = function() {
    fireScrollEvent()
  };

  let scrollFired = false;
  var fireScrollEvent = _debounce(scrollEventHandler, 300);
  function scrollEventHandler() {
    const h = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    const minScrollHeight = 100;
    if (!scrollFired && h >= minScrollHeight) {
      scrollFired = true;
      fireCustomEvent('xiaoying_scroll');
    }
  }

  function _debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result;
    var later = function() {
      const last = Date.now() - timestamp;
      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };
    return function() {
      context = this;
      args = arguments;
      timestamp = Date.now();
      const callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }
      return result;
    };
  };
}

function inmobiPush() {
  fireCustomEvent('registered_xiaoying')
}

function kuaiShouInit() {
  (function (root) {
    var ksscript = document.createElement('script');
    ksscript.type = 'text/javascript';
    ksscript.src = 'https://static.yximgs.com/udata/pkg/ks-ad-trace-sdk/ks-trace.2.0.0.beta.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ksscript, s);
  })(window);
}
// 链接上加callback 用来上报
export function kuaishouPush() {
  if (window._ks_trace) {
    _ks_trace.push({event: 'form', convertId: 2656, cb: function(){
        console.log('kuaishou success！')
      }})
  }
}

export function regEventInit(c) {
  config = c // 缓存配置
  if (config.reportType == 2 && config.toutiaoId && config.toutiaoType) {
    const toutiao = {
      'convert_id': config.toutiaoId,
      'event_type': config.toutiaoType
    };
    toutiaoInit(toutiao);
  }
  if (config.reportType == 3 && config.doumengReportValue == 1) {
    doumengInit();
  }
  if (config.extend.is_baidu == 1) {
    baiduInit();
  }
  if (config.extend.is_360 == 1) {
    js360Init();
  }
  if (config.extend.is_inmobi == 1) {
    inmobiInit();
  }
  if (config.extend.is_kuaishou == 1) {
    kuaiShouInit();
  }
  if(config.extend.is_mta == 1){
    mtaInit()
  }
  return true;
}
export function regEventPush() {
  toutiaoPush();
  doumengPush();
  baiduPush();
  js360Push();
  kuaishouPush();
  inmobiPush();
}

export default {regEventInit, regEventPush, inmobiEvent};
